let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8ZPpF")).then(() => parcelRequire('bSYPS'));